module.exports = __webpack_public_path__ + "img/82.e359ee56.jpg";